export default __webpack_public_path__ + "static/media/mini3.4a924866.png";